// extracted by mini-css-extract-plugin
export var colophon = "footer-module--colophon--izhtU";